import React from 'react';
import { FormControlLabel, Checkbox, Box } from '@mui/material';

export default function BaseEnvironmentField({ value, onChange, edit }) {
  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            onChange={handleChange}
            disabled={edit}
          />
        }
        label='Customer Provided'
      />
    </Box>
  );
}

